import React, { Component } from "react";
import PropTypes from "prop-types";

import Notification from "./Notification";

import {
  CLAIM,
  CHALLENGE,
  PROJECT_USER,
  USER,
  PROJECT_PROFILE,
  PROFILE,
  PROJECT_TEAM,
  TOPIC_COMMENTS_THREAD,
  CHALLENGE_COMMENTS_THREAD,
  CLAIM_COMMENTS_THREAD
} from "App/Routes";
import localize from "lang/localize";

const propTypes = {
  notifications: PropTypes.array.isRequired,
  more: PropTypes.bool.isRequired,
  handleMore: PropTypes.func.isRequired,
  language: PropTypes.string,
  projectId: PropTypes.number,
  userId: PropTypes.number
};

class NotificationsPage extends Component {
  getURL(type, id, contextId) {
    switch (type) {
      case "claim":
        return CLAIM.format(id);
      case "challenge":
        return CHALLENGE.format(id);
      case "user":
        if (this.props.userId === id && this.props.projectId) {
          return PROJECT_PROFILE.format(this.props.projectId);
        } else if (this.props.userId === id) {
          return PROFILE;
        } else if (this.props.projectId) {
          return PROJECT_USER.format(this.props.projectId, id);
        } else {
          return USER.format(id);
        }
      case "team":
        return PROJECT_TEAM.format(this.props.projectId, id);
      case "thread_topic":
        return TOPIC_COMMENTS_THREAD.format(contextId, id);
      case "thread_challenge":
        return CHALLENGE_COMMENTS_THREAD.format(contextId, id);
      case "thread_completion":
        return CLAIM_COMMENTS_THREAD.format(contextId, id);
      default:
        return null;
    }
  }

  renderNotifcations() {
    const notifications = this.props.notifications;
    return notifications.map((notification, index) => (
      <Notification
        key={index} // can't use id cause some have same id
        id={notification.id}
        title={notification.content}
        img={notification.photoSmall}
        time={notification.createdAtFormatted}
        type={notification.type}
        link={this.getURL(
          notification.type,
          notification.id,
          notification.contextId
        )}
        bold={!notification.read}
      />
    ));
  }

  render() {
    return (
      <div className="container verticalpadding bottompadding-floating">
        <div className="innerblock pure-g">
          <div className="pure-u-1-1 pure-u-md-1-6" />
          <div className="pure-u-1-1 pure-u-md-2-3">
            {this.renderNotifcations()}
            {this.props.more ? (
              <button
                className="button automargin"
                onClick={this.props.handleMore}
              >
                {localize("more_text", this.props.language)}
              </button>
            ) : null}
          </div>
          <div className="pure-u-1-1 pure-u-md-1-6" />
        </div>
      </div>
    );
  }
}

NotificationsPage.propTypes = propTypes;

export default NotificationsPage;
